var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Country(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-country",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7189",
    "data-name": "Rectangle 7189",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x36_40_x2C__Country_x2C__flag_x2C__usa",
    transform: "translate(-14.455 -85.099)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_950",
    "data-name": "Group 950",
    transform: "translate(15.327 88.76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_949",
    "data-name": "Group 949",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_948",
    "data-name": "Group 948"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_940",
    "data-name": "Group 940",
    transform: "translate(0 3.435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_934",
    "data-name": "Group 934",
    transform: "translate(2.943 2.943)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    d: "M79.524,234.342a.462.462,0,0,1-.078-.917c1.412-.245,1.867-1.219,2.444-2.452a6.649,6.649,0,0,1,4.01-4.058.462.462,0,1,1,.31.87,5.724,5.724,0,0,0-3.484,3.579c-.608,1.3-1.236,2.643-3.122,2.971A.464.464,0,0,1,79.524,234.342Z",
    transform: "translate(-79.063 -226.888)",
    fill: "#adb5b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_935",
    "data-name": "Group 935",
    transform: "translate(1.959 1.959)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    d: "M58.212,213.03a.462.462,0,0,1-.078-.917c1.412-.245,1.867-1.219,2.444-2.452a6.649,6.649,0,0,1,4.01-4.058.462.462,0,0,1,.31.87,5.724,5.724,0,0,0-3.484,3.579c-.608,1.3-1.236,2.644-3.122,2.971A.465.465,0,0,1,58.212,213.03Z",
    transform: "translate(-57.751 -205.577)",
    fill: "#adb5b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_936",
    "data-name": "Group 936",
    transform: "translate(0.979 4.537)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    d: "M37,265.319a.462.462,0,0,1-.078-.917c1.412-.245,1.867-1.219,2.444-2.452l.123-.262a.462.462,0,0,1,.835.395l-.121.258c-.608,1.3-1.236,2.644-3.122,2.971A.462.462,0,0,1,37,265.319Z",
    transform: "translate(-36.537 -261.424)",
    fill: "#adb5b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_937",
    "data-name": "Group 937"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    d: "M19.746,174.564a.461.461,0,0,1-.326-.135l-3.958-3.958a.462.462,0,0,1,.248-.781c1.412-.245,1.867-1.219,2.444-2.452a6.649,6.649,0,0,1,4.01-4.058.462.462,0,0,1,.482.108l4,4a.462.462,0,0,1-.171.761,5.789,5.789,0,0,0-3.506,3.558c-.618,1.29-1.257,2.623-3.141,2.95A.476.476,0,0,1,19.746,174.564Zm-3.076-4.191L19.9,173.6c1.239-.307,1.683-1.234,2.237-2.391a6.876,6.876,0,0,1,3.368-3.757l-3.3-3.3a5.781,5.781,0,0,0-3.213,3.476A4.68,4.68,0,0,1,16.67,170.373Z",
    transform: "translate(-15.327 -163.153)",
    fill: "#adb5b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_938",
    "data-name": "Group 938",
    transform: "translate(9.876 3.347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    d: "M235.606,242.472a.46.46,0,0,1-.326-.135l-5.917-5.917a.462.462,0,1,1,.653-.653l5.917,5.917a.462.462,0,0,1-.326.788Z",
    transform: "translate(-229.227 -235.632)",
    fill: "#adb5b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_939",
    "data-name": "Group 939",
    transform: "translate(3.007 3.517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    d: "M82.783,242.123a.461.461,0,0,1-.326-.135l-1.866-1.866a.462.462,0,0,1,.653-.653l1.866,1.866a.462.462,0,0,1-.326.788Z",
    transform: "translate(-80.456 -239.334)",
    fill: "#adb5b9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_947",
    "data-name": "Group 947",
    transform: "translate(12.099)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_941",
    "data-name": "Group 941",
    transform: "translate(0 4.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    d: "M285.347,181.05a6.914,6.914,0,0,1-2.327-.552,5.724,5.724,0,0,0-4.994-.067.462.462,0,1,1-.4-.834,6.649,6.649,0,0,1,5.7.034c1.28.464,2.29.831,3.462.006a.462.462,0,0,1,.532.755A3.344,3.344,0,0,1,285.347,181.05Z",
    transform: "translate(-277.367 -178.957)",
    fill: "#adb5b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_942",
    "data-name": "Group 942",
    transform: "translate(0 2.773)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    d: "M285.347,150.91a6.915,6.915,0,0,1-2.327-.552,5.724,5.724,0,0,0-4.994-.068.462.462,0,1,1-.4-.834,6.649,6.649,0,0,1,5.7.034c1.28.464,2.291.831,3.462.006a.462.462,0,0,1,.532.755A3.344,3.344,0,0,1,285.347,150.91Z",
    transform: "translate(-277.367 -148.817)",
    fill: "#adb5b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_943",
    "data-name": "Group 943",
    transform: "translate(5.079 1.935)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    d: "M390.267,132.215a6.915,6.915,0,0,1-2.327-.552l-.269-.1a.462.462,0,0,1,.311-.869l.272.1c1.28.464,2.29.831,3.462.006a.462.462,0,1,1,.532.755A3.343,3.343,0,0,1,390.267,132.215Z",
    transform: "translate(-387.365 -130.669)",
    fill: "#adb5b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_944",
    "data-name": "Group 944",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    d: "M285.323,96.461a6.957,6.957,0,0,1-2.3-.533,7.91,7.91,0,0,0-2.678-.6,5.331,5.331,0,0,0-2.317.559.462.462,0,0,1-.66-.417V89.819a.462.462,0,0,1,.264-.417,6.164,6.164,0,0,1,2.683-.642,8.646,8.646,0,0,1,3.022.675,6.2,6.2,0,0,0,2.008.5,2.438,2.438,0,0,0,1.454-.493.462.462,0,0,1,.728.377v5.6a.462.462,0,0,1-.2.378A3.4,3.4,0,0,1,285.323,96.461Zm-4.977-2.052a8.764,8.764,0,0,1,2.985.648,6.307,6.307,0,0,0,1.992.48,2.392,2.392,0,0,0,1.281-.371V90.6a3.2,3.2,0,0,1-1.258.254,6.854,6.854,0,0,1-2.322-.554,7.793,7.793,0,0,0-2.707-.62,5.123,5.123,0,0,0-2.023.434v4.664A5.952,5.952,0,0,1,280.346,94.409Z",
    transform: "translate(-277.369 -88.76)",
    fill: "#adb5b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_945",
    "data-name": "Group 945",
    transform: "translate(0 6.149)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    d: "M277.831,231.225a.462.462,0,0,1-.462-.462V222.4a.462.462,0,0,1,.923,0v8.367A.462.462,0,0,1,277.831,231.225Z",
    transform: "translate(-277.369 -221.934)",
    fill: "#adb5b9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_946",
    "data-name": "Group 946",
    transform: "translate(4.978 0.593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    d: "M385.646,105.173a.462.462,0,0,1-.462-.462v-2.639a.462.462,0,0,1,.923,0v2.639A.462.462,0,0,1,385.646,105.173Z",
    transform: "translate(-385.184 -101.611)",
    fill: "#adb5b9"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Country);
export default __webpack_public_path__ + "static/media/icon-24-country.858e20b2e6758e54a14ddfa75845d63c.svg";
export { ForwardRef as ReactComponent };